import { KeyInfo } from '../../components/common/types'
import {
  BaseActionType,
  DELETE_ENDORSEMENT_KEYS_SUCCESS,
  LOAD_ENDORSEMENT_KEYS_SUCCESS,
  LOAD_MORE_ENDORSEMENT_KEYS_SUCCESS,
  UPDATE_ENDORSEMENT_KEYS_SUCCESS,
  UPLOAD_ENDORSEMENT_KEYS_SUCCESS,
} from '../actions/actionTypes'

import { KeysReducerState } from './initialState'

const initialStateEndorsementKeys: KeysReducerState = {
  keys: [],
  continuationToken: '',
}

export function endorsementKeysReducer(
  state = initialStateEndorsementKeys,
  action: BaseActionType,
): KeysReducerState {
  switch (action.type) {
    case UPDATE_ENDORSEMENT_KEYS_SUCCESS: {
      const endorsementKeys: KeyInfo[] = state.keys.map(
        (endorsementKey: KeyInfo) =>
          endorsementKey.keyId === (action.payload as KeyInfo).keyId
            ? (action.payload as KeyInfo)
            : endorsementKey,
      )
      return { ...state, keys: [...endorsementKeys] }
    }
    case LOAD_ENDORSEMENT_KEYS_SUCCESS:
      return action.payload as KeysReducerState
    case LOAD_MORE_ENDORSEMENT_KEYS_SUCCESS:
      return {
        continuationToken: (action.payload as KeysReducerState)
          .continuationToken,
        keys: [...state.keys, ...(action.payload as KeysReducerState).keys],
      }
    case DELETE_ENDORSEMENT_KEYS_SUCCESS: {
      const endorsementKeys = state.keys.filter(
        (endorsementKeys: KeyInfo) =>
          endorsementKeys.keyId !== (action.payload as KeyInfo).keyId,
      )
      return { ...state, keys: endorsementKeys }
    }
    case UPLOAD_ENDORSEMENT_KEYS_SUCCESS: {
      return {
        ...state,
        keys: [action.payload as KeyInfo, ...state.keys],
      }
    }
    default:
      return state
  }
}
